// Alphabet de base 32 de Crockford, empreinte stable et lecture d'un code tapé à la main : ce dont le
// téléphone a besoin pour lire un code. Aucune dépendance : repris par l'appli compagnon. L'attribution
// des codes et des pages, qui ne sert qu'à la compilation, est dans placement.ts.

/** Base 32 de Crockford : chiffres et lettres, sans I, L, O ni U, qu'on confond à la main. */
export const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

/** Empreinte FNV-1a sur 32 bits d'un texte, stable d'une machine à l'autre. */
export function empreinte(texte: string): number {
  let h = 0x811c9dc5;
  for (const octet of new TextEncoder().encode(texte)) {
    h ^= octet;
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h >>> 0;
}

/**
 * Normalise une saisie à la main selon les règles de Crockford : majuscules, sans espace ni tiret,
 * I et L lus comme 1, O lu comme 0.
 */
export function normaliserCode(saisie: string): string {
  return saisie
    .toUpperCase()
    .replace(/[\s-]/g, '')
    .replace(/[IL]/g, '1')
    .replace(/O/g, '0');
}
